import AuthService from "../../services/AuthService";
import { tokenStorage } from "../../utils/tokenStorage";
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  FETCH_PROFILE_REQUEST,
  FETCH_PROFILE_SUCCESS,
  FETCH_PROFILE_FAILURE,
} from "./actionTypes";

const loginRequest = () => ({ type: LOGIN_REQUEST });
const loginSuccess = () => ({ type: LOGIN_SUCCESS });
const loginFailure = (error) => ({ type: LOGIN_FAILURE, payload: error });

export const logout = () => {
  tokenStorage.clear();
  return { type: LOGOUT };
};

/** Thunk: authenticate, persist the session token, update the store. */
export const login = (username, password) => async (dispatch) => {
  dispatch(loginRequest());
  try {
    const result = await AuthService.login(username, password);

    if (!result.responceType) {
      throw new Error(result.responceMessage || "Invalid username or password.");
    }

    tokenStorage.set(result.credentialToken);
    dispatch(loginSuccess());
    return true;
  } catch (err) {
    const message =
      err?.response?.data?.responceMessage ||
      err?.message ||
      "Unable to log in. Please try again.";
    dispatch(loginFailure(message));
    return false;
  }
};

const fetchProfileRequest = () => ({ type: FETCH_PROFILE_REQUEST });
const fetchProfileSuccess = (profile) => ({
  type: FETCH_PROFILE_SUCCESS,
  payload: profile,
});
const fetchProfileFailure = (error) => ({
  type: FETCH_PROFILE_FAILURE,
  payload: error,
});

/** Thunk: fetch the logged-in user's display details. */
export const fetchProfile = () => async (dispatch) => {
  dispatch(fetchProfileRequest());
  try {
    const profile = await AuthService.getProfile();
    dispatch(fetchProfileSuccess(profile));
    return profile;
  } catch (err) {
    const message = err?.message || "Unable to load your profile.";
    dispatch(fetchProfileFailure(message));
    return null;
  }
};
